import { useSelector } from 'react-redux'
import type { CodeRootState, RootState } from '../../redux/types'

export const useCodeSelector = <T>(codeSelector: (codeState: CodeRootState) => T): T => {
  return useSelector(({ codeReducer }: RootState) => codeSelector(codeReducer))
}
